import { combineReducers } from "redux";
import AuthReducer from "modules/auth/reducer";
import UserReducer from "modules/users/reducer";
import CongregationReducer from "modules/congregation/reducer";

/**
 * @variable RootReducer
 * @description Combined all reducer into root reducer
 */
const RootReducer = combineReducers({
  AuthReducer,
  CongregationReducer,
  usersInfo: UserReducer,
});

export default RootReducer;
